import { createSlice } from "@reduxjs/toolkit";
import {
    getVendor,
    createManager,
    createVendor,
    getTransactionHistory,
    getViewDeposit,
    getViewPurchase,
    createCollection,
    getFullUsers,
    createDeposit,
    getDepositPurchase,
    createPurchase,
    getSale,
    createSales,
    createShipment,
    createCustomers,
    customerClosing,
    getProfit,
    getGroup,
    createGroup,
    getGlobals,
    editGlobals,
    viewDashbord
} from './thunk';
import Shipment from "pages/Dashboards/Ecommerce/Shipment";

export const initialState: any = {
    maillist: [],
    managerList: [],
    vendor: [],
    vendorList: [],
    deposit: [],
    users: [],
    userList: [],
    purchase: [],
    collection: [],
    depositAmount: [],
    transactionHistory: [],
    error: {},
    depositfull: [],
    paymentfull: [],
    purchaseList: [],
    sale: [],
    salelist: [],
    ShipmentList: [],
    shipUpdate: [],
    closingList: [],
    profit: 0,
    group: [],
    groupList: [],
    globals: [],
    dashbord:[],
    isLoader: false
};

const SettingsSlice = createSlice({
    name: 'Settings',
    initialState,
    reducers: {},
    extraReducers: (builder) => {

        builder.addCase(createManager.fulfilled, (state: any, action: any) => {
            state.managerList.unshift(action.payload);
        });
        builder.addCase(createManager.rejected, (state: any, action: any) => { 
            state.error = action.payload?.error || "Unknown error";
        });


        builder.addCase(getVendor.fulfilled, (state: any, action: any) => {
            state.vendor = action.payload;
        });
        builder.addCase(getFullUsers.fulfilled, (state: any, action: any) => {
            state.users = action.payload;
        });

        builder.addCase(createVendor.fulfilled, (state: any, action: any) => {
            state.vendorList.unshift(action.payload);
        });
        builder.addCase(createVendor.rejected, (state: any, action: any) => {
            state.error = action.payload.error || null;
        });

        builder.addCase(getTransactionHistory.fulfilled, (state: any, action: any) => {
            state.transactionHistory = action.payload;
        });
        builder.addCase(getViewDeposit.fulfilled, (state: any, action: any) => {
            state.deposit = action.payload;
        })
        builder.addCase(getViewPurchase.fulfilled, (state: any, action: any) => {
            state.purchase = action.payload;
        })



        builder.addCase(createCollection.fulfilled, (state: any, action: any) => {
            state.collection.unshift(action.payload);
            state.error = {};
        });
        builder.addCase(createCollection.rejected, (state: any, action: any) => {
            state.error = action.payload || { message: "Collection creation failed" };
        });


        builder.addCase(createDeposit.fulfilled, (state: any, action: any) => {
            state.depositAmount.unshift(action.payload);
        });
        builder.addCase(createDeposit.rejected, (state: any, action: any) => {
            state.error = action.payload.error || null;
        });
        builder.addCase(getDepositPurchase.fulfilled, (state: any, action: any) => {
            state.depositfull = action.payload.deposit || null;
            state.paymentfull = action.payload.payment || null
        });

        builder.addCase(createPurchase.fulfilled, (state: any, action: any) => {
            state.purchaseList.unshift(action.payload);
        });
        builder.addCase(createPurchase.rejected, (state: any, action: any) => {
            state.error = action.error.message || null;
        });
        builder.addCase(getSale.fulfilled, (state: any, action: any) => {
            state.sale = action.payload;
        })

        builder.addCase(createSales.fulfilled, (state: any, action: any) => {
            state.salelist.unshift(action.payload);
        });
        builder.addCase(createSales.rejected, (state: any, action: any) => {
            state.error = action.payload.error || null;
        });


        builder.addCase(createShipment.fulfilled, (state: any, action: any) => {
            state.ShipmentList.unshift(action.payload);
        });
        builder.addCase(createShipment.rejected, (state: any, action: any) => {
            state.error = action.payload.error || null;
        });

        builder.addCase(createCustomers.fulfilled, (state: any, action: any) => {
            state.userList.unshift(action.payload);
        });
        builder.addCase(createCustomers.rejected, (state: any, action: any) => {
            state.error = action.payload.error || null;
        });
        builder.addCase(customerClosing.fulfilled, (state: any, action: any) => {
            state.closingList.unshift(action.payload);
        });
        builder.addCase(customerClosing.rejected, (state: any, action: any) => {
            state.error = action.payload.error || null;
        });

        builder.addCase(getProfit.fulfilled, (state: any, action: any) => {
            state.profit = action.payload;
        });


        builder.addCase(getGroup.fulfilled, (state: any, action: any) => {
            state.group = action.payload;
        });

        builder.addCase(createGroup.fulfilled, (state: any, action: any) => {
            state.groupList.unshift(action.payload);
        });
        builder.addCase(createGroup.rejected, (state: any, action: any) => {
            state.error = action.payload.error || null;
        });
        builder.addCase(getGlobals.fulfilled, (state: any, action: any) => {
            state.globals = action.payload;
        });
        builder.addCase(editGlobals.fulfilled, (state: any, action: any) => {
            state.globals = action.payload;
        });

        builder.addCase(editGlobals.rejected, (state: any, action: any) => {
            state.error = action.payload || "Failed to update global values";
        });
         builder.addCase(viewDashbord.fulfilled, (state: any, action: any) => {
            state.dashbord = action.payload;
        });

    }
});

export default SettingsSlice.reducer;  